import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../../components/Converter";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function AnzahlHalbwellen({ anzahlHalbwellen = 0 }) {
  const { t } = useTranslation("translation");
  const m_Formula = `\\displaystyle m = \\frac{L}{\\pi} \\cdot \\sqrt[4]{\\frac{c}{EI_{s}}}`;
  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.Verification.numberHalfCycles")}</p>}
      indicesValue={<span>m</span>}
      formulaValue={<ToolTip id={"m_Formula"} type={IconType.FORMULA} formula={m_Formula} />}
      inputValue={<span className="input">{ConvertToString(anzahlHalbwellen, 1)}</span>}
    />
  );
}

export default AnzahlHalbwellen;
